import { useMediaQuery } from "@/hooks/useMediaQuery";
import { mediaQuery } from "@/theme/tokens";

/** Returns true when the user has requested reduced motion. */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery(mediaQuery.reducedMotion);
}
